import Check from 'components/assets/icons/Check'
import { GetPageIndex } from 'components/RCPro/helpers/nav'
import style from './Menu.module.scss'

const Menu = ({texts}) => {

  const { menu1, menu2 } = texts
  if (!menu1) return

  const steps = [
    { activeAt: 1, doneAt: 3 },
    { activeAt: 3, doneAt: 4 },
    { activeAt: 4, doneAt: 6 },
    { activeAt: 6, doneAt: 7 }
  ].map( (step, idx) => ({
    ...step,
    text: menu1 ? menu1[idx] : ''
  }))

  const steps2 = [
    { activeAt: 9, doneAt: 10 },
    { activeAt: 10, doneAt: 11 },
    { activeAt: 11, doneAt: 12 },
    { activeAt: 12, doneAt: 14 }
  ].map( (step, idx) => ({
    ...step,
    text: menu2 ? menu2[idx] : ''
  }))

  const pageIndex = GetPageIndex()

  const currentMenu = pageIndex > 6
    ? steps2
    : steps

  return (
    <ul className={style.menu}>
      {
        currentMenu.map( (step, index) => (
          <li key={`nav-${index}`} className={pageIndex >= step.activeAt ? style.active : undefined}>
            {pageIndex >= step.doneAt
             ? <Check />
             : index+1
            }
            <span>{step.text}</span>
          </li>
        ))
      }
    </ul>
  )
}

export default Menu